import React from "react";
import {observer} from "mobx-react-lite"
import StringUtil from "../../utils/StringUtil";
import modalStore from "../modal/modalStore";
import { UserStore } from "../../common/user/store/UserStore";

type SessionInfoProp = {
    userStore: UserStore;
    isAdmin: boolean;
}

const SessionInfo = ({userStore, isAdmin}: SessionInfoProp) => {
    const [remainTime, setRemainTime] = React.useState("");
    const [minute, setMinute] = React.useState(120);
    const [second, setSecond] = React.useState(0);

    const [userInfo, setUserInfo] = React.useState<{
        personNm?:string;
        corpNm?:string;
    }>({
        personNm:"",
        corpNm:""
    });

    React.useEffect(() => {
        const rt = userStore.sessionRemainTime;
        if (typeof rt === 'number') {
            setMinute(Math.floor(rt / 60))
            setSecond(Math.floor( rt % 60 ));
            if(rt > 0 && rt <= 600) {
                showTimer();
            }
            else if (rt <= 0) {
                modalStore.show = false;
                userStore.logoutQuietly(isAdmin).then();
            }
        }
    }, [userStore.sessionRemainTime]);

    React.useEffect(() => {
        setRemainTime(minute + ":" + StringUtil.leftPad(String(second), 2, "0"));
    }, [minute, second]);

    const sessionExtendHandler = () => {
        userStore.resetSession(true).then()
    }

    React.useEffect(()=> {
        setUserInfo({
            personNm: userStore.userModel?.personNm,
            corpNm: userStore.userModel?.tbCommCorp.corpNm
        })
    }, [userStore.userModel])

    const showTimer = () => {
        modalStore.modal(<><span className="fc-pri">{minute}분 {second}초</span> 후 자동 로그아웃됩니다.</>, false, result => {
            sessionExtendHandler();
        });
    }

    return (
        <>
            <span>
                {userInfo.corpNm + " "}
                <em className='user-name'>{userInfo.personNm}</em>님
                    (남은시간 세션 <em className='user-session'>{remainTime}</em>)
            </span>
            <button className='btn-session-extend' type='button' onClick={sessionExtendHandler}>연장
            </button>
        </>
    )
};

export default observer(SessionInfo);